"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var it = {
  'contractSelectorMessages.contractDetails': 'Dettagli del contratto',
  'contractSelectorMessages.discount': 'Sconto',
  'contractSelectorMessages.items': 'Articoli',
  'contractSelectorMessages.lastModified': 'Ultima modifica',
  'contractSelectorMessages.lastModifiedBy': 'Ultima modifica apportata da',
  'contractSelectorMessages.markup': 'Markup',
  'contractSelectorMessages.revision': 'Revisione',
  'createOptionStep.contractNamePlaceholder': 'es. Durata del prezzo del catalogo {name}',
  'createOptionStep.header': 'Vi sono già contratti di prezzo del catalogo con {name}. Aggiungere i prodotti al contratto esistente o crearne uno nuovo',
  'createOptionStep.newOptionButtonDescription': 'Creare nuovo contratto con {name}',
  'createOptionStep.newOptionButtonTitle': 'Inizia nuovo contratto',
  'createOptionStep.updateExistingOptionButtonDescription': 'Aggiungere le sku al contratto esistente con \n{name}',
  'createOptionStep.updateExistingOptionButtonTitle': 'Aggiorna contratto esistente',
  'generalModal.backButtonText': 'Indietro',
  'generalModal.closeButtonText': 'Chiudi',
  'generalModal.defaultErrorCreationMessage': 'Errore durante la creazione del contratto di prezzo del catalogo',
  'generalModal.financialFlowsSupport': 'Assistenza relativa ai flussi finanziari',
  'generalModal.forAssistanceText': 'per assistenza',
  'generalModal.nextButtonText': 'Successivo',
  'generalModal.pleaseContactText': 'Contattare',
  'generalModal.termButtonCreatedStatus': 'Creato',
  'generalModal.termButtonCreatingStatus': 'Creazione in corso',
  'generalModal.termButtonDefaultText': "Invia per l'approvazione",
  'generalModal.title': 'Inizia un contratto di prezzo del catalogo',
  'generalModal.viewPendingContractText': 'Cliccare qui per visualizzare il contratto in sospeso in Contract Manager',
  'listPriceConfirmStep.allSkusHaveContractsErrorMessage': 'Tutte le sku hanno un contratto di prezzo del catalogo tra {merchantName} e {fulfillerName}',
  'listPriceConfirmStep.buyer': 'Acquirente',
  'listPriceConfirmStep.confirmContractDetails': 'Conferma dettagli del contratto',
  'listPriceConfirmStep.discount': 'Sconto',
  'listPriceConfirmStep.endDate': 'Data finale',
  'listPriceConfirmStep.errorLoadingSkusMessage': 'Errore durante il caricamento delle sku',
  'listPriceConfirmStep.excludedSkus': 'Esclusi ({count})',
  'listPriceConfirmStep.includedSkus': 'Sku ({count})',
  'listPriceConfirmStep.markup': 'Markup',
  'listPriceConfirmStep.name': 'Nome',
  'listPriceConfirmStep.noEndDate': 'Nessuna data di fine',
  'listPriceConfirmStep.seller': 'Venditore',
  'listPriceConfirmStep.skusHaveContractsWarning': 'Un contratto di prezzo del catalogo tra {fulfillerName} e {merchantName} già esiste per queste sku',
  'listPriceConfirmStep.startDate': 'Data iniziale',
  'listPriceCreateStep.existingHeader': 'Selezionare dai Contratti del Catalogo con {name}',
  'listPriceCreateStep.newHeader': 'Assegnare un nome al contratto',
  'listPriceInitiatorButton.listPriceInitiatorButtonText': 'Inizia contratto',
  'listPriceInitiatorButton.noIdentityMessage': "Non si dispone dell'identità di negoziante per eseguire questa azione",
  'listPriceInitiatorButton.noSkusSelectedMessage': 'È necessario selezionare SKU valide prima di creare un contratto',
  'listPriceInitiatorButton.tooltipMessage': '{message}. Per assistenza, contattare {email}',
  'selectMerchantStep.header': 'Selezionare il negoziante che acquista i prodotti',
  'selectMerchantStep.merchantSelectLabel': 'Negoziante',
  'skuSelector.apiErrorTemplate': 'Errore durante {serviceComment}. (Codice di risposta: {status})',
  'skuSelector.apiSceneServiceComment': "acquisizione dell'uri del luogo in corso",
  'skuSelector.apiSkuServiceComment': 'ricerca delle sku in corso',
  'skuSelector.csvDownloadLink': '{number} Sku totali (Cliccare qui per scaricare CSV)',
  'skuSelector.csvDownloadName': 'all_skus.csv',
  'skuSelector.currentlyViewingText': 'Visualizzazione corrente',
  'skuSelector.descriptionFilterLabel': 'Descrizione',
  'skuSelector.emptyBinPlaceholder': 'Cercare i prodotti per nome o SKU e aggiungerli qui.',
  'skuSelector.filterOptionsTitle': 'Opzioni Filtro',
  'skuSelector.nameFilterLabel': 'Nome',
  'skuSelector.removeSkuButtonText': 'Rimuovi SKU',
  'skuSelector.searchFilterLabel': 'Filtra per parola chiave',
  'skuSelector.skuBinNoFilterResult': "Nessun risultato trovato per '{filter}'.",
  'skuSelector.skuCardDisabledTooltip': "Il selettore è al momento disabilitato. Questo prodotto non può essere aggiunto o rimosso dall'elenco.",
  'skuSelector.skuCountText': 'su {totalCount} sku',
  'skuSelector.skuFilterLabel': 'Sku',
  'skuSelector.skuSearchAddSkuButtonText': 'Aggiungi SKU',
  'skuSelector.skuSearchAddSkuPrompt': 'Aggiungere più sku in una volta?',
  'skuSelector.skuSearchBarHelpText': 'Iniziare a digitare in alto per cercare i prodotti',
  'skuSelector.skuSearchBarLabel': 'Digitare un nome del prodotto o una SKU',
  'skuSelector.skuSearchDefaultErrorMessage': 'Qualcosa è andato storto',
  'skuSelector.skuSearchDetailedErrorMessage': '{error}. Riprovare.',
  'skuSelector.skuSearchNextButtonText': 'Successivo',
  'skuSelector.skuSearchNotFoundErrorMessage': "Nessun prodotto trovato per '{query}'",
  'skuSelector.skuSearchPrevButtonText': 'Precedente',
  'skuSelector.uploadModalAddButtonText': 'Aggiungi ({totalCount})',
  'skuSelector.uploadModalAddError': 'Non è stato possibile aggiungere le SKU presenti in alto poiché non esistono nella piattaforma.  Potrebbero contenere errori di battitura, quali caratteri non alfanumerici o uso delle lettere maiuscole improprio. Rivederle e riprovare.',
  'skuSelector.uploadModalAddTitle': 'Aggiungi SKU',
  'skuSelector.uploadModalCloseButtonText': 'Chiudi',
  'skuSelector.uploadModalHelpText': "Inserire un elenco di SKU separate da spazi. L'esecuzione di migliaia di SKU in una sola volta potrebbe richiedere del tempo. Se si verificano ritardi consistenti, provare a eseguire diversi caricamenti più piccoli.",
  'skuSelector.uploadModalRemoveButtonText': 'Rimuovi ({totalCount})',
  'skuSelector.uploadModalRemoveError': 'Non è stato possibile rimuovere le SKU presenti in alto dal momento che sono segnate come irremovibili.',
  'skuSelector.uploadModalRemoveTitle': 'Rimuovi SKU',
  'skuSelector.uploadModalSkuLabel': 'SKU',
  'skuSelector2.apiErrorTemplate': 'Errore durante {serviceComment}. (Codice di risposta: {status})',
  'skuSelector2.apiSceneServiceComment': "acquisizione dell'uri del luogo in corso",
  'skuSelector2.apiSkuServiceComment': 'Suche nach Produkt-IDs',
  'skuSelector2.csvDownloadLink': '{numero} ID prodotto totali (fai clic qui per scaricare CSV)',
  'skuSelector2.csvDownloadName': 'all_skus.csv',
  'skuSelector2.currentlyViewingText': 'Visualizzazione corrente',
  'skuSelector2.descriptionFilterLabel': 'Descrizione',
  'skuSelector2.emptyBinPlaceholder': "Cerca i prodotti in base al nome o all'ID prodotto e aggiungili qui.",
  'skuSelector2.filterOptionsTitle': 'Opzioni Filtro',
  'skuSelector2.nameFilterLabel': 'Nome',
  'skuSelector2.removeSkuButtonText': 'Rimuovi ID prodotto',
  'skuSelector2.searchFilterLabel': 'Filtra per parola chiave',
  'skuSelector2.skuBinNoFilterResult': "Nessun risultato trovato per '{filter}'.",
  'skuSelector2.skuCardDisabledTooltip': "Il selettore è al momento disabilitato. Questo prodotto non può essere aggiunto o rimosso dall'elenco.",
  'skuSelector2.skuCountText': 'su {totalCount} ID prodotto',
  'skuSelector2.skuFilterLabel': 'Numero identificativo del prodotto',
  'skuSelector2.skuSearchAddSkuButtonText': 'Aggiungi ID prodotto',
  'skuSelector2.skuSearchAddSkuPrompt': 'Vuoi aggiungere più ID prodotto contemporaneamente?',
  'skuSelector2.skuSearchBarHelpText': 'Iniziare a digitare in alto per cercare i prodotti',
  'skuSelector2.skuSearchBarLabel': 'Digitare un nome di prodotto o ID prodotto',
  'skuSelector2.skuSearchDefaultErrorMessage': 'Qualcosa è andato storto',
  'skuSelector2.skuSearchDetailedErrorMessage': '{error}. Riprovare.',
  'skuSelector2.skuSearchNextButtonText': 'Successivo',
  'skuSelector2.skuSearchNotFoundErrorMessage': "Nessun prodotto trovato per '{query}'",
  'skuSelector2.skuSearchPrevButtonText': 'Precedente',
  'skuSelector2.uploadModalAddButtonText': 'Aggiungi ({totalCount})',
  'skuSelector2.uploadModalAddError': 'Non è stato possibile aggiungere gli ID prodotto sopra riportati perché non esistono sulla piattaforma. Possono contenere errori di battitura, come caratteri non alfanumerici o lettere maiuscole non corrette. Esaminali e riprova.',
  'skuSelector2.uploadModalAddTitle': 'Aggiungi ID prodotto',
  'skuSelector2.uploadModalCloseButtonText': 'Chiudi',
  'skuSelector2.uploadModalHelpText': "Immettere un elenco di ID prodotto separati da spazi. L'elaborazione di migliaia di ID prodotto contemporaneamente può richiedere del tempo. Se riscontri ritardi significativi, prova a fare diversi caricamenti più piccoli.",
  'skuSelector2.uploadModalRemoveButtonText': 'Rimuovi ({totalCount})',
  'skuSelector2.uploadModalRemoveError': 'Non è stato possibile rimuovere gli ID prodotto sopra riportati perché contrassegnati come non rimovibili.',
  'skuSelector2.uploadModalRemoveTitle': 'Rimuovi ID prodotto',
  'skuSelector2.uploadModalSkuLabel': 'ID prodotto'
};
var _default = it;
exports.default = _default;